import {useEffect, useState} from "react";
import {IPeriod} from "../../utils/interfaces/IPeriod";
import InvoicesList from "./InvoicesList";
import {useAccounting} from "../../utils/contexts/accounting_context";
import {csvHeaders, invoice_csv_data} from "../../logics/csv-export";
import {CSVLink} from "react-csv";
import {PiCheckFatFill, PiFileCsv} from "react-icons/pi";


interface PeriodRowProps {
    obj: IPeriod,
}

function PeriodRow({obj: initialObj}: PeriodRowProps) {
    const {selectedPeriod, selectPeriod, selectedYear} = useAccounting()
    const [obj, setObj] = useState<IPeriod>(initialObj)

    const csv_data = (period: IPeriod) => {
        const transformedData: Array<Record<string, any>> = [];
        const invoices = period.invoices;
        invoices.forEach((invoice) => {
            const invoiceData = invoice_csv_data(invoice);
            invoiceData.forEach((record) => {
                record.year = selectedYear?.year;
                record.month = period.month;
            });
            transformedData.push(...invoiceData);
        });

        return transformedData;
    };


    const handleSelect = (obj: IPeriod) => {
        (selectedPeriod === obj) ?
            selectPeriod(undefined) :
            selectPeriod(obj);
    }

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])


    return (
        <>
            <div className="flex flex-row items-stretch mb-1.5">
                <button
                    className="mycia_accounting_button_period"
                    key={obj.month_name}
                    onClick={() => handleSelect(obj)}
                >
                    {obj.month_name}
                </button>
                <div>
                    <div className="flex flex-row">

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Prenotazioni</label>
                                <div className="text_span">
                                    {obj.totals.bookings.monthly_count.toFixed(0)}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Coperti</label>
                                <div className="text_span">
                                    {obj.totals.bookings.monthly_seats.toFixed(0)}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Imponibile</label>
                                <div className="text_span">
                                    {obj.totals.bookings.monthly_nett_price.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="flex flex-row">

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Ordini</label>
                                <div className="text_span">
                                    {obj.totals.transactions.monthly_count.toFixed(0)}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Imponibile</label>
                                <div className="text_span">
                                    {obj.totals.transactions.monthly_amount.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Mycia Commission</label>
                                <div className="text_span">
                                    {obj.totals.transactions.monthly_mycia_amount.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Stripe Commission</label>
                                <div className="text_span">
                                    {obj.totals.transactions.monthly_stripe_commission_amount.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Total Commission</label>
                                <div className="text_span">
                                    {obj.totals.transactions.monthly_commission_amount.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Saldo</label>
                                <div className="text_span">
                                    {obj.totals.transactions.monthly_balance_amount.toFixed(2)} €
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="flex flex-row">
                        <div className="cisco_totals_div">
                            <div className="content-container">
                                <label>Studio Cisco:</label>
                            </div>
                        </div>

                        <div className="cisco_totals_div">
                            <div className="content-container">
                                <label>Imponibile Prenotazioni</label>
                                <div className="text_span">
                                    {obj.totals.bookings.monthly_nett_price.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                        <div className="cisco_totals_div">
                            <div className="content-container">
                                <label>Imponibile Rebounds</label>
                                <div className="text_span">
                                    {obj.totals.rebounds.monthly_to_invoice_amount.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="cisco_totals_div ml-0.5">
                    <label>Imponibile Fatturato</label>
                    <div className="text_span">
                        {obj.totals.monthly_invoices.monthly_total_invoiced.toFixed(2)}
                    </div>
                    {
                        (obj.totals.monthly_invoices.monthly_total_invoiced === obj.totals.monthly_invoices.monthly_total_to_invoice) ?
                            (<PiCheckFatFill className='mt-1 text-transparent'/>)
                            :
                            (<PiCheckFatFill className='mt-1'
                                             color={obj.totals.monthly_invoices.monthly_total_invoiced === 0 ? 'transparent' : ''}/>)
                    }
                </div>
                <div
                    className="cisco_totals_div ml-0.5">
                    <label>Imponibile da Fatturare</label>
                    <div className="text_span">
                        {obj.totals.monthly_invoices.monthly_total_to_invoice.toFixed(2)}
                    </div>
                    <PiCheckFatFill className='mt-1 text-transparent'/>
                </div>
                <button
                    className="bg-mcia_orange hover:bg-mcia_salmon text-white font-bold py-2 px-4 rounded mb-0.5  shadow-xl ml-0.5">
                    <CSVLink
                        data={csv_data(obj)}
                        headers={csvHeaders}
                        filename="exported-data.csv"
                        separator=";"
                        className="d-flex align-items-center justify-content-center"
                        target="_blank"
                    >
                        <PiFileCsv style={{fontSize: '36px'}}/>
                    </CSVLink>
                </button>

            </div>
            {(selectedPeriod?.month === obj.month) ?
                <InvoicesList obj={obj}/>
                :
                ''
            }
        </>
    )
}

export default PeriodRow;